import RoutesConfig from "../components/home/Routes";

function HomePage() {
  return <RoutesConfig />;
}

export default HomePage;
